import { Box } from '@mui/material';

interface BlockingOverlayProps {
  isVisible: boolean;
}

export const BlockingOverlay = ({ isVisible }: BlockingOverlayProps) => {
  if (!isVisible) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(255, 255, 255, 0)',
        cursor: 'wait',
        zIndex: 9999,
      }}
    />
  );
};
